<template lang='pug'>
v-container
  v-card(
    light
    flat
    outlined
  )
    v-card-title
      | Macro Calculator
    v-container(
      fluid
    )
      EventToProp(
        v-slot='{ prop: calories_total, updateProp: calories_total_update, timestamp }'
      )
        v-row
          v-col(
            cols='12'
            sm='6'
            lg='8'
            xl='10'
          )
            MacroCalculatorFormCalories2(
              :initial_carbs='$store.state.settings.carbs'
              :initial_fat='$store.state.settings.fat'
              :initial_protein='$store.state.settings.protein'
              @update:carbs='result => $store.commit("update_carbs", result)'
              @update:fat='result => $store.commit("update_fat", result)'
              @update:protein='result => $store.commit("update_protein", result)'
              @update:calories_total='calories_total_update'
            )
          v-col(
            cols='12'
            sm='6'
            lg='4'
            xl='2'
          )
            PieChart2(
              :initial_carbs='$store.state.settings.carbs'
              :initial_fat='$store.state.settings.fat'
              :initial_protein='$store.state.settings.protein'
              :isDark='true'
            )
</template>

<script>
import EventToProp from '@thomasphan/vue-components/src/components/EventToProp.vue';
import MacroCalculatorFormCalories2 from '@thomasphan/vue-components/src/components/MacroCalculatorFormCalories2.vue';
import PieChart2 from '@thomasphan/vue-components/src/components/PieChart2.vue';

export default
{
  components:
  {
    EventToProp,
    MacroCalculatorFormCalories2,
    PieChart2,
  }
};
</script>